import { render, staticRenderFns } from "./AgcoLog.vue?vue&type=template&id=352452fe&scoped=true"
import script from "./AgcoLog.vue?vue&type=script&lang=js"
export * from "./AgcoLog.vue?vue&type=script&lang=js"
import style0 from "./AgcoLog.vue?vue&type=style&index=0&id=352452fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352452fe",
  null
  
)

export default component.exports